<div class="mt-2 table-container">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <!-- Checkbox Column -->
        <!-- <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? toggleAllRows() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                </mat-checkbox>
            </td>
        </ng-container> -->
        <!-- Checkbox Column close -->

        <ng-container matColumnDef="day">
            <th translate mat-header-cell *matHeaderCellDef> Day </th>
            <td mat-cell *matCellDef="let element"> {{element.day}} </td>
        </ng-container>

        <ng-container matColumnDef="weeks_in_month">
            <th translate mat-header-cell *matHeaderCellDef> Weeks In Month </th>
              <td mat-cell *matCellDef="let element">
                {{ getFormattedWeeks(element.weeks_in_month) }}
              </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)">
        </tr>
        <tr class="mat-row" *matNoDataRow>
            <td translate class="mat-cell" colspan="4">No data</td>
        </tr>
    </table>
</div>
<div class="mt-2" *ngIf="total_count > 5">
    <app-pagination [datafromparent]="total_count" (onDatePicked)="pagination($event)"></app-pagination>
</div>